import { render, staticRenderFns } from "./view-content-dialog.vue?vue&type=template&id=edc458f8&scoped=true"
import script from "./view-content-dialog.vue?vue&type=script&lang=js"
export * from "./view-content-dialog.vue?vue&type=script&lang=js"
import style0 from "./view-content-dialog.vue?vue&type=style&index=0&id=edc458f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edc458f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edc458f8')) {
      api.createRecord('edc458f8', component.options)
    } else {
      api.reload('edc458f8', component.options)
    }
    module.hot.accept("./view-content-dialog.vue?vue&type=template&id=edc458f8&scoped=true", function () {
      api.rerender('edc458f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/content/view-content-dialog.vue"
export default component.exports